import * as React from 'react';
import { MultiKeyValueComponent } from '../common/types';
import { SelectType, SelectCommonProps } from '../common/select/types';
import { SelectBaseComponent } from '../common/select/select-base-component';

export interface SelectMultipleHierarchyProps extends MultiKeyValueComponent<number|string>, SelectCommonProps {
  /**
   * It allows user to select node from min level of hierarchy codes.
   * Default is 0.
   */
  minLevel?: number;
  /**
   * It allows user to select only leaf in hierarchy codes.
   * Default is false.
   */
  leafNodeOnly?: boolean;
  /**
   * It shows whole path from root in description of selected option.
   * Default is false.
   */
  descriptionAllLevels?: boolean;

  /**
   * @internal
   */
  hideSearchInput?: boolean;
  /**
   * It differentiates whether has levels or not.
   * Default is false.
   */
  levelsNotAllowed?: boolean;
  locale: string;
}

export class SelectMultipleHierarchy extends React.Component<SelectMultipleHierarchyProps> {
  public render() {
    return <SelectBaseComponent
      {...this.props}
      selectType={SelectType.multipleHierarchy}
    />;
  }
}
